import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useResourceAssignmentDialogContext } from '../ResourceAssignmentDialogContext';
import useDeleteResourceRequest from './useDeleteResourceRequest';

const matchingRequest = id => request => id === request.id;

const useResourceAssignmentEventHandlers = ({
  onCloseAssignmentDialog,
  resourceRequests,
  isResourceActualModeEnabled,
  isPSAActualCornerCasesEnabled
}) => {
  const { setExpandedResourceRequestId } = useResourceAssignmentDialogContext();
  const history = useHistory();
  const deleteResourceRequest = useDeleteResourceRequest({
    isResourceActualModeEnabled,
    isPSAActualCornerCasesEnabled
  });
  const onDeleteResourceRequest = useCallback(
    async ({ request, resourceRequestID, isPSARMP2023Q3BugsEnabled }) => {
      await deleteResourceRequest({
        request
      });
      const index = !isPSARMP2023Q3BugsEnabled
        ? resourceRequests.findIndex(matchingRequest(resourceRequestID))
        : resourceRequests.findIndex(matchingRequest(request?.id));
      const nextIndex =
        resourceRequests.length - 1 > index ? index + 1 : index - 1;
      const nextFocusExpandedRequest = resourceRequests[nextIndex];

      if (nextFocusExpandedRequest) {
        setExpandedResourceRequestId(nextFocusExpandedRequest.id);
        history.replace(nextFocusExpandedRequest.id);
      } else {
        onCloseAssignmentDialog();
      }
    },
    [
      deleteResourceRequest,
      history,
      onCloseAssignmentDialog,
      resourceRequests,
      setExpandedResourceRequestId
    ]
  );

  return { onDeleteResourceRequest };
};

export default useResourceAssignmentEventHandlers;
